import { useEffect, useRef } from 'react';

export const useDidUpdateEffect = (
  callback: () => void,
  dependencies: Array<unknown>,
) => {
  const isMountingRef = useRef(false);

  useEffect(() => {
    // This enables strict mode compatibility, because this
    // will be called twice on the first render.
    isMountingRef.current = true;
  }, []);

  useEffect(() => {
    if (isMountingRef.current) {
      isMountingRef.current = false;
    } else {
      callback();
    }
  }, dependencies);
};
